"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgPipeLeakageFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.pipe-leakage_filled_svg__cls-1{display:none}')),
        React.createElement("g", { id: "pipe-leakage_filled_svg__transparent_box" },
            React.createElement("path", { className: "pipe-leakage_filled_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "pipe-leakage_filled_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "pipe-leakage_filled_svg__FILLED" },
            React.createElement("path", { d: "M16 18.54l-.72.78C14.92 19.69 12 23 12 25.88a4 4 0 108 0c0-3.13-3.16-6.44-3.29-6.58zM28 4H4v2h11.21l.68 2.69-2 2 .82 3.31H4v2h24v-2H16.78l-.68-2.69 2-2L17.28 6H28V4z" }))));
}
exports.default = SvgPipeLeakageFilled;
//# sourceMappingURL=PipeLeakageFilled.js.map